// extracted by mini-css-extract-plugin
export var activityContainer = "_fm-0";
export var typingIndicatorContainer = "_fm-1";
export var typingIndicatorDot = "_fm-2";
export var wave = "_fm-3";